import type { IUploadFileParams } from 'core/model/interfaces/downloads-uploads';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../uploads.constants';
import type { IUploadsState } from '../uploads.types';

export const uploadFileByFileType = createAppAsyncThunk<unknown, IUploadFileParams>(
  `${SLICE_NAMESPACE}/uploadFileByFileType`,
  async (params: IUploadFileParams) => {
    try {
      const response = await apiService.uploads.uploadFile(params);

      notificationService.global.success('Se descargó archivo excel correctamente.');

      return response;
    } catch (error) {
      notificationService.drawer.error('Error al cargar el archivo. Por favor Inténtalo de nuevo.');

      throw error;
    }
  },
);

export const uploadFileByFileTypeReducer: TSliceExtraReducer<IUploadsState> = builder =>
  builder
    .addCase(uploadFileByFileType.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(uploadFileByFileType.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(uploadFileByFileType.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
